//////////////////
// Utilities
//////////////////
App.Utilities = (function() {

	App.register(function() {
		App.log("Registered: App.Utilities");
	});


  return {

    // Small screen checker
    isSmallScreen: function() {
    	// Use a simple CSS state checker to establish device mode
    	var checker = $(".is-mob");
    	return(checker.css("display") == "block");
    },

    mapPlaceholderTemplate: function(template, data) {
      // Get template (using moustache handlebar syntax)
      var html = template;
      // Iterate through options
      for(var name in data) {
        var val = data[name];
        // Replace global options of that instance
        html = html.replace(new RegExp("{{" + name + "}}", "g"), val);
      }
      // Return HTML
      return(html);
    }

  }
})();
